import { createIcon } from './icon-utils';

export const CommentsIcon = createIcon({
  path: 'M6 21.75l4.8-3.6a.75.75 0 01.45-.15h10.5a.75.75 0 00.75-.75v-15a.75.75 0 00-.75-.75H2.25a.75.75 0 00-.75.75v15c0 .414.336.75.75.75h3a.75.75 0 01.75.75v3zM4.5 19.5H2.25A2.25 2.25 0 010 17.25v-15A2.25 2.25 0 012.25 0h19.5A2.25 2.25 0 0124 2.25v15a2.25 2.25 0 01-2.25 2.25H11.5l-5.8 4.35a.75.75 0 01-1.2-.6V19.5zm.75-11.25a.75.75 0 010-1.5h13.5a.75.75 0 110 1.5H5.25zm0 4.5a.75.75 0 110-1.5h10.5a.75.75 0 110 1.5H5.25z',
});
